import React from 'react';

import {Icon, IconName} from '@shared/ui/Icon';

import {Card, IconBox, Label, Value} from './styled';

interface MetricCardProps {
    label: React.ReactNode;
    value: React.ReactNode;
    icon?: React.ReactNode;
    iconColor?: string;
    iconName?: IconName;
    className?: string;
}

export const MetricCard = ({
    label,
    value,
    icon,
    iconColor,
    iconName,
    className,
}: MetricCardProps) => (
    <Card className={className} $hasIcon={Boolean(iconName || icon)}>
        {(iconName || icon) && (
            <IconBox color={iconColor}>
                {iconName ? <Icon name={iconName} color="white" size={24} /> : icon}
            </IconBox>
        )}
        <Label>{label}</Label>
        <Value>{value}</Value>
    </Card>
);

export {MetricCardGrid} from './styled';
